/* global axios */
import ApiClient from './ApiClient';

// Conexão unificada (Instagram + Facebook) por ID da Página, na área de Integrações.
class MetaConnectionAPI extends ApiClient {
  constructor() {
    super('meta/connection', { accountScoped: true });
  }

  getStatus() {
    return axios.get(this.url);
  }

  connect(pageId) {
    return axios.post(this.url, { page_id: pageId });
  }

  disconnect(channel) {
    const params = channel ? { channel } : {};
    return axios.delete(this.url, { params });
  }
}

export default new MetaConnectionAPI();
